import {fsa, fsaPayload, fsaError, fsaPayloadByKeys} from './helpers'

export const GET_FIT_PROFILE = 'get user fit profile asynchronously'
export const getFitProfile = fsa(GET_FIT_PROFILE)

export const GET_FIT_PROFILE_PENDING = 'get user fit profile pending'
export const getFitProfilePending = fsa(GET_FIT_PROFILE_PENDING)

export const GET_FIT_PROFILE_FAILURE = 'get user fit profile failure'
export const getFitProfileFailure = fsaError(GET_FIT_PROFILE_FAILURE)

export const GET_FIT_PROFILE_SUCCESS = 'get user fit profile success'
export const getFitProfileSuccess = fsaPayload(GET_FIT_PROFILE_SUCCESS)

export const SET_FIT_PROFILE = 'set user fit profile asynchronously'
export const setFitProfile = fsaPayloadByKeys(SET_FIT_PROFILE, ['fitProfileData'])

export const SET_FIT_PROFILE_PENDING = 'set user fit profile pending'
export const setFitProfilePending = fsa(SET_FIT_PROFILE_PENDING)

export const SET_FIT_PROFILE_FAILURE = 'set user fit profile failure'
export const setFitProfileFailure = fsaError(SET_FIT_PROFILE_FAILURE)

export const SET_FIT_PROFILE_SUCCESS = 'set user fit profile success'
export const setFitProfileSuccess = fsaPayload(SET_FIT_PROFILE_SUCCESS)
